import { Controller } from "@hotwired/stimulus"
import TomSelect from "@lib/custom-tom-select"
import { get as getFetch  } from "@lib/requests"

// Connects to data-controller="product-items"
export default class extends Controller {

  static targets = ["group", "product", "container", "header", "body", "row", "submit"]
  
  connect() {
    // Destroy existing Tom Select instance if it exists (e.g., from previous connection)
    if (this.productTarget.tomselect) {
      this.productTarget.tomselect.destroy()
    }

    this.productSelect = new TomSelect(this.productTarget, { 
      labelField: "label",
      searchField: [],
      valueField: "id",
      load: this.loadProducts.bind(this),
      onChange: this.onProductSelect.bind(this),
      shouldLoad: function(query) {
        return true;  // Always trigger the load function (so we can clear the options on blank queries)
      }
    })
    // Store initial options
    this.productSelect.setInitialOptions(this.productSelect.options)
    this.productSearchNavigated = false
    this.ignoreInitialEnterSelection(this.productSelect, () => this.productSearchNavigated, value => this.productSearchNavigated = value)
    this.productSelect.focus()
  }

  disconnect() {
    if (this.productSelect) {
      this.productSelect.destroy()
    }
  }

  get rows() {
    return this.rowTargets
  }

  get hiddenForm() {
    return !this.rows.length
  }

  get disabledForm() {
    return this.hiddenForm || [...this.rows].every(row => row.dataset.disabled !== undefined)
  }

  get inMainSearchInput() {
    return this.productTarget.tomselect?.control?.contains(document.activeElement)
  }

  async loadProducts(query, callback) {
    // Clear both the selection and options
    this.productSelect.clear(true)
    this.productSelect.clearOptions()
    
    if (!query.trim()) {
      // Restore initial options when query is cleared
      callback(this.productSelect.initialOptions)
      return
    }
    
    let url = `/api/v1/products?q=${query}`
    const response = await fetch(url, { headers: { accept: "application/json" } })
    const products = await response.json()
    callback(products || [])
  }
  
  updateFormStatus() {
    this.hiddenForm ? this.headerTarget.classList.add("hidden") : this.headerTarget.classList.remove("hidden")
    this.disabledForm ? this.submitTarget.setAttribute("disabled", "disabled") : this.submitTarget.removeAttribute("disabled")
  }
  
  async onProductSelect(value) {
    if (!value) return

    this.productSelect.clearSelect()
    this.productSearchNavigated = false
    const group = this.groupTarget.value
    await getFetch(`/product-groups/${group}/add-row?product_id=${value}`, { responseKind: "turbo-stream" })
    setTimeout(this.updateFormStatus.bind(this), 100)
  }

  ignoreInitialEnterSelection(select, hasNavigated, setNavigated) {
    const originalOnKeyDown = select.onKeyDown

    select.hook("instead", "onKeyDown", event => {
      if (event.key === "ArrowDown" || event.key === "ArrowUp") {
        setNavigated(true)
      }

      if (event.key === "Enter" && !select.inputValue().trim() && !hasNavigated()) {
        event.preventDefault()
        event.stopPropagation()
        return
      }

      return originalOnKeyDown.call(select, event)
    })
  }

  submitOnEnter(event) {
    if (event.isComposing || this.inMainSearchInput || this.disabledForm) return

    event.preventDefault()
    this.element.requestSubmit(this.submitTarget)
  }

  delete(e) {
    e.target.closest("[data-product-items-target='row']").remove()
    this.updateFormStatus()
  }

}
